export default __webpack_public_path__ + "static/media/NK_cell_enrichment_workflow.db295f4b.png";